import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_3 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "font-bold tracking-wider leading-tight text-2xl mt-0" }
const _hoisted_6 = { class: "capitalize" }
const _hoisted_7 = { class: "flex items-center justify-between" }
const _hoisted_8 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg" }
const _hoisted_9 = { class: "flex flex-col gap-3 items-start mb-3" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = {
  class: /*@__PURE__*/_normalizeClass('input-wrapper')
}
const _hoisted_12 = { class: "capitalize text-xs" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = {
  class: /*@__PURE__*/_normalizeClass('input-wrapper')
}
const _hoisted_15 = { class: "text-xs" }
const _hoisted_16 = { class: "flex xl:flex-row flex-col gap-3 items-start mb-3" }
const _hoisted_17 = {
  key: 0,
  class: "w-full xl:w-1/2 mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnConfirmModal = _resolveComponent("ReturnConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.item.integrationProvider ? _ctx.item.integrationProvider : 'Add New Access Key'), 1),
              _createTextVNode(" - " + _toDisplayString(_ctx.visibleToken(_ctx.item.integrationValue)), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteRecord())),
                class: "cursor-pointer rounded-md bg-white text-theme-red py-2 px-4 hover:bg-theme-darkgreen hover:text-white mr-3"
              }, "DELETE"),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args)), ["prevent"])),
                class: "cursor-pointer rounded-md text-white py-2 pl-2 hover:opacity-70"
              }, "CLOSE")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "text-xs mb-1" }, "Name:", -1)),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.item.integrationProvider), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "text-xs mb-1" }, "Token:", -1)),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.visibleToken(_ctx.item.integrationValue)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.form.integrationProvider.value == 'clover')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.deleteObj.modal)
      ? (_openBlock(), _createBlock(_component_ReturnConfirmModal, {
          key: 0,
          obj: _ctx.deleteObj.obj,
          closeClick: _ctx.closeDeleteModal,
          actionClick: _ctx.deleteNow,
          heading: 'You Are About To Delete ' + _ctx.deleteObj.obj.integrationProvider 
        }, null, 8, ["obj", "closeClick", "actionClick", "heading"]))
      : _createCommentVNode("", true)
  ], 64))
}